import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getDashboardDataRequest, getDashboardDataRequestError, getDashboardDataRequestSuccess } from "../../slices/dashboard/GetDashboardDataSlice";

export const GetDashboardDataApi = () => async (dispatch) => {
    try {
        dispatch(getDashboardDataRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.dashboardData,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getDashboardDataRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getDashboardDataRequestError(_error));
            });
    } catch (error) { }
};
